module.exports = __webpack_public_path__ + "static/media/header_bg_md.e8a49faf.webp";